import { mutator } from 'satcheljs';
import { editExistingFavoriteInStore } from '../actions/v2/editFavoriteActions';
import { getOutlookFavoritesForOutlookFavoriteKind } from '../utils/getOutlookFavoritesForNodeType';

mutator(editExistingFavoriteInStore, actionMessage => {
    const { updatedFavoriteData } = actionMessage;
    const favoriteKind = updatedFavoriteData.type;

    if (!favoriteKind) {
        throw new Error('editExistingFavoriteInStore: FavoriteType must be provided');
    }

    const favoritesOftype = getOutlookFavoritesForOutlookFavoriteKind(favoriteKind);
    const existingFavorite = favoritesOftype.get(updatedFavoriteData.favoriteId);

    if (!existingFavorite) {
        throw new Error('Could not find a favorite with the provided ID to edit');
    }

    const updatedFavorite = { ...existingFavorite, ...updatedFavoriteData };
    favoritesOftype.set(existingFavorite.favoriteId, updatedFavorite);
});
